































import Vue from "vue";
import {imgModalStructure,imgInfoStructure} from './imageInfo'
import { lightbox } from "../store/modal_store";
import { setTimeout } from 'timers';

export default Vue.extend({
  data() {
    return {
        activeImage:<number>0,
        activeInfo:<boolean>false,
        expandMessage:<string>"Show More",
        mainImageWidth:<number>0
    };
  },
  components: {
  },
  computed: {
    lightbox_img_src(): string {
      return this.$store.state.lightbox.img_src
    },
    displayLightbox(): boolean {
      return this.$store.state.lightbox.display_lightbox
    },
    lightbox_img_carousel(): imgModalStructure [] {
        return this.$store.state.lightbox.img_carousel
    },
    currentImage():string {
        if (this.lightbox_img_carousel.length != 0) {
            return this.lightbox_img_carousel[this.activeImage].img_src
        } else {
            return this.$store.state.lightbox.img_src
        }
    },
    img_info(): imgInfoStructure {
        return this.$store.state.lightbox.img_info
    },
    caption_width(): any {
        return {
            width: `${this.mainImageWidth}px`
        }
    },
  },
  methods: {
    /**
     * Closes the modal, sets the lightbox img source to be ""
     */
    close_modal():void {
      this.$store.commit('remove_lightbox')
      this.$store.commit('set_lightbox_img', {
        img_src: ""})
    },
    /**
     * Sets main image as the image at index imageIndex
     * @param {number} imageIndex the target index of the image to be displayed
     */
    activateImage(imageIndex:number):void {
        this.activeImage = imageIndex
        setTimeout(() => {
            this.getMainImageWidth()
        }, 10)
    },
    /**
     * toggles the "Show Less" and "Show More" display, in turn toggling the appropriate class for display
     */
    activateInfo():void {
        if(!this.activeInfo){
            this.activeInfo = true
            this.expandMessage = "Show Less"
        } else {
            this.activeInfo = false
            this.expandMessage = "Show More"            
        }
    },
    /**
     * Get width of the main image to set figcaption tag group width, needs to be computed as the width of the image changes
     * The setTimeout function allows the image to be rendered before setting the corresponding width.
     */
    getMainImageWidth():void {
        let targetClass = document.getElementsByClassName('currentImage_class')
        setTimeout(() => {
            if (targetClass.length != 0) {
                let width = targetClass[0].clientWidth
                this.mainImageWidth = width
            }            
        }, 25)
    },
    /**
     * Uses Vuex store to toggle show_next_img
     */
    showNextImg():void {
        this.$store.commit('show_next_img', {
            state: true})
        this.getMainImageWidth()
    },
    /**
     * Uses Vuex store to toggle show_prev_img
     */    
    showPrevImg():void {
        this.$store.commit('show_prev_img', {
            state: true})
        this.getMainImageWidth()    
    }
  },
  mounted() {
        this.getMainImageWidth()
        window.addEventListener('resize',this.getMainImageWidth)    
  }
})
